import React from 'react';

import { SortingDirection, SortingOffersValue } from '../../constants/enums';

interface SortableHeaderProps {
  label: string;
  sortValue: SortingOffersValue;
  currentSortValue: SortingOffersValue;
  currentDirection: SortingDirection;
  onSort: (sortValue: SortingOffersValue, direction: SortingDirection) => void;
}

export const SortableHeader: React.FC<SortableHeaderProps> = ({
  label,
  sortValue,
  currentSortValue,
  currentDirection,
  onSort
}) => (
  <div
    className="cursor-pointer hover:text-base-foreground flex items-center gap-1"
    onClick={() => {
      const newDirection =
        currentDirection === SortingDirection.ASC
          ? SortingDirection.DESC
          : SortingDirection.ASC;
      onSort(sortValue, newDirection);
    }}
  >
    {label}
    <span className="text-xs">
      {currentSortValue === sortValue &&
        (currentDirection === SortingDirection.ASC ? '↑' : '↓')}
    </span>
  </div>
);

export default SortableHeader;
